import React, { useState, useEffect } from 'react';
import { CloseOutlined, PlusOutlined, SaveOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import PageLayout from '../../components/PageLayout';
import useIsMobile from '../../hooks/useIsMobile';
import ActionLoader from '../../components/ActionLoader';
import FormInput from '../../components/FormInput';
import Toast from '../../components/Toast';

import HeaderIconSvg from '../../icons/newicons/arrow-down-up.svg';
import CancelSettlement from '../../icons/pos_cancel.png';
import AddSettlement from '../../icons/pos_add_load.png';
import CaretIcon from '../../icons/caret.png';

import { SUBMIT_SETTLEMENT_INFO, postData } from '../../utils/api';

import DatePicker from 'react-datepicker';
import CurrencyFormat from 'react-currency-format';
import 'react-datepicker/dist/react-datepicker.css';
import './index.css';

const _ = require('lodash');

const CreateSettlement = (props) => {
  const isMobile = useIsMobile();

  const { item, selectedCustomer } = props.location.state;

  const [isLoading, setIsLoading] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [validations, setValidations] = useState({});
  const [submitIsLoading, setSubmitIsLoading] = useState(false);

  const [inputData, setInputData] = useState({});

  const [shippingDocs, setShippingDocs] = useState({
    gross: '',
    tare: '',
    net: '',
    total: '',
  });
  const [mmiReceived, setMmiReceived] = useState({
    gross: '',
    tare: '',
    net: '',
    total: '',
  });
  const [mmiProcessed, setMmiProcessed] = useState({
    monoNet: '',
    monoDry: '',
    bhdNet: '',
    bhdDry: '',
    samplesNet: '',
    samplesDry: '',
    trashNet: '',
    trashDry: '',
    magneticsNet: '',
    magneticsDry: '',
    totalProcessedNet: '',
    totalProcessedDry: '',
  });

  const [createHedge, setCreateHedge] = useState(false);
  const [hedgeDetails, setHedgeDetails] = useState({
    hedgeNo: '',
    hedgeDate: '',
    ptOz: '',
    ptUnitPrice: '',
    pdOz: '',
    pdUnitPrice: '',
    rhOz: '',
    rhUnitPrice: '',
  });
  const [hedgeTableData, setHedgeTableData] = useState([]);

  const [createLot, setCreateLot] = useState(false);
  const [lotDetails, setLotDetails] = useState({
    lotNo: '',
    sampleNo: '',
    h2O: '',
    netDry: '',
    sampleDry: '',
    ptPpm: '',
    ptOz: '',
    pdPpm: '',
    pdOz: '',
    rhPpm: '',
    rhOz: '',
  });
  const [lotTableData, setLotTableData] = useState([]);

  const [product, setProduct] = useState({
    ptMetalReturn: {},
    pdMetalReturn: {},
    rhMetalReturn: {},
    ptRefiningCharge: {},
    pdRefiningCharge: {},
    rhRefiningCharge: {},
    advInvoice: {},
    intInvoice: {},
    tc: {},
    sc: {},
    af: {},
    espi: {},
    fi: {},
    totalCharges: '',
    totalSettlementAmount: '',
  });

  const [toastParams, setToastParams] = useState({
    message: '',
    type: '',
    id: '',
  });

  const cellStyle = {
    border: '1px solid black',
    padding: '8px',
    textAlign: 'center',
  };

  const goBack = () => {
    props.history.goBack();
  };

  useEffect(() => {
    setShippingDocs({
      ...shippingDocs,
      net:
        shippingDocs.gross != '' || shippingDocs.tare != ''
          ? parseFloat(
              ((shippingDocs?.gross || 0) - (shippingDocs?.tare || 0)).toFixed(
                2
              )
            )
          : '',
      total:
        shippingDocs.gross != '' || shippingDocs.tare != ''
          ? parseFloat(
              ((shippingDocs?.gross || 0) - (shippingDocs?.tare || 0)).toFixed(
                2
              )
            )
          : '',
    });
  }, [shippingDocs.gross, shippingDocs.tare]);

  useEffect(() => {
    setMmiReceived({
      ...mmiReceived,
      net:
        mmiReceived.gross != '' || mmiReceived.tare != ''
          ? parseFloat(
              ((mmiReceived?.gross || 0) - (mmiReceived?.tare || 0)).toFixed(3)
            )
          : '',
      total:
        mmiReceived.gross != '' || mmiReceived.tare != ''
          ? parseFloat(
              ((mmiReceived?.gross || 0) - (mmiReceived?.tare || 0)).toFixed(3)
            )
          : '',
    });
  }, [mmiReceived.gross, mmiReceived.tare]);

  useEffect(() => {
    setMmiProcessed({
      ...mmiProcessed,
      totalProcessedNet:
        mmiProcessed.monoNet != '' ||
        mmiProcessed.bhdNet != '' ||
        mmiProcessed.samplesNet != '' ||
        mmiProcessed.trashNet != '' ||
        mmiProcessed.magneticsNet != ''
          ? parseFloat(
              (
                (mmiProcessed?.monoNet || 0) +
                (mmiProcessed?.bhdNet || 0) +
                (mmiProcessed?.samplesNet || 0) +
                (mmiProcessed?.trashNet || 0) +
                (mmiProcessed?.magneticsNet || 0)
              ).toFixed(3)
            )
          : '',
      totalProcessedDry:
        mmiProcessed.monoDry != '' ||
        mmiProcessed.bhdDry != '' ||
        mmiProcessed.samplesDry != '' ||
        mmiProcessed.trashDry != '' ||
        mmiProcessed.magneticsDry != ''
          ? parseFloat(
              (
                (mmiProcessed?.monoDry || 0) +
                (mmiProcessed?.bhdDry || 0) +
                (mmiProcessed?.samplesDry || 0) +
                (mmiProcessed?.trashDry || 0) +
                (mmiProcessed?.magneticsDry || 0)
              ).toFixed(3)
            )
          : '',
    });
  }, [
    mmiProcessed.monoNet,
    mmiProcessed.bhdNet,
    mmiProcessed.samplesNet,
    mmiProcessed.trashNet,
    mmiProcessed.magneticsNet,
    mmiProcessed.monoDry,
    mmiProcessed.bhdDry,
    mmiProcessed.samplesDry,
    mmiProcessed.trashDry,
    mmiProcessed.magneticsDry,
  ]);

  const productData = {
    header: [
      'Product',
      'Charge / Return Type',
      'Invoice Number',
      'Advance Date',
      'Total Ounces',
      'Charge/ Return ($ %)',
      'Quantity',
      'Avg Price',
      'Charge/Return',
    ],
    data: [
      [
        'PT',
        'Metal Return %',
        'ptMetalReturn_invoiceNo_text',
        'ptMetalReturn_advanceDate_date',
        'ptMetalReturn_totalOunces_number_nonInput',
        'ptMetalReturn_chargeReturnPerc_number',
        'ptMetalReturn_quantity_number_nonInput',
        'ptMetalReturn_avgPrice_number_nonInput',
        'ptMetalReturn_chargeReturn_number_nonInput',
      ],
      [
        'PD',
        'Metal Return %',
        'pdMetalReturn_invoiceNo_text',
        'pdMetalReturn_advanceDate_date',
        'pdMetalReturn_totalOunces_number_nonInput',
        'pdMetalReturn_chargeReturnPerc_number',
        'pdMetalReturn_quantity_number_nonInput',
        'pdMetalReturn_avgPrice_number_nonInput',
        'pdMetalReturn_chargeReturn_number_nonInput',
      ],
      [
        'RH',
        'Metal Return %',
        'rhMetalReturn_invoiceNo_text',
        'rhMetalReturn_advanceDate_date',
        'rhMetalReturn_totalOunces_number_nonInput',
        'rhMetalReturn_chargeReturnPerc_number',
        'rhMetalReturn_quantity_number_nonInput',
        'rhMetalReturn_avgPrice_number_nonInput',
        'rhMetalReturn_chargeReturn_number_nonInput',
      ],
      [
        '',
        '',
        '',
        '',
        '',
        '',
        'Metal Return Value ($)',
        '',
        'metalReturn_chargeReturn_number_nonInput',
      ],
      [
        'PT',
        'Refining Charge',
        '',
        '',
        '',
        'ptRefiningCharge_chargeReturnPerc_number',
        'ptRefiningCharge_quantity_number_nonInput',
        '',
        'ptRefiningCharge_chargeReturn_number_nonInput',
      ],
      [
        'PD',
        'Refining Charge',
        '',
        '',
        '',
        'pdRefiningCharge_chargeReturnPerc_number',
        'pdRefiningCharge_quantity_number_nonInput',
        '',
        'pdRefiningCharge_chargeReturn_number_nonInput',
      ],
      [
        'RH',
        'Refining Charge',
        '',
        '',
        '',
        'rhRefiningCharge_chargeReturnPerc_number',
        'rhRefiningCharge_quantity_number_nonInput',
        '',
        'rhRefiningCharge_chargeReturn_number_nonInput',
      ],
      [
        'ADV',
        'Invoice',
        '',
        '',
        '',
        '',
        'advInvoice_quantity_number',
        '',
        'advInvoice_chargeReturn_number',
      ],
      [
        'INT',
        'Invoice',
        '',
        '',
        '',
        'intInvoice_chargeReturnPerc_number',
        'intInvoice_quantity_number',
        '',
        'intInvoice_chargeReturn_number_nonInput',
      ],
      [
        'TC',
        'Treatment Charge',
        '',
        '',
        '',
        'tc_chargeReturnPerc_number',
        'tc_quantity_number',
        '',
        'tc_chargeReturn_number_nonInput',
      ],
      [
        'SC',
        'Sample Shipping',
        '',
        '',
        '',
        'sc_chargeReturnPerc_number',
        'sc_quantity_number',
        '',
        'sc_chargeReturn_number_nonInput',
      ],
      [
        'AF',
        'Assay Fee',
        '',
        '',
        '',
        'af_chargeReturnPerc_number',
        'af_quantity_number',
        '',
        'af_chargeReturn_number_nonInput',
      ],
      [
        'ESPI',
        'Early Settlement Payment Int',
        '',
        '',
        '',
        'espi_chargeReturnPerc_number',
        'espi_quantity_number',
        'espi_average_number_nonInput',
        'espi_chargeReturn_number_nonInput',
      ],
      [
        'FI',
        'Freight Inland',
        '',
        '',
        '',
        'fi_chargeReturnPerc_number',
        'fi_quantity_number',
        '',
        'fi_chargeReturn_number_nonInput',
      ],
      [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        'Total Charges ($)',
        'totalCharges_number_nonInput',
      ],
      [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        'Total Settlement Amt ($)',
        'totalSettlementAmount_number_nonInput',
      ],
    ],
  };

  useEffect(() => {
    if (item) {
      setInputData({
        settlementNo: item?.settlementNo,
        contractNo: item?.contractNo,
        shipmentNo: item?.shipmentNo,
        receivedDate: item?.receivedDate,
        metalDueDate: item?.metalDueDate,
      });

      setShippingDocs(item?.shippingDocs || {});
      setMmiProcessed(item?.mmiProcessed || {});
      setMmiReceived(item?.mmiReceived || {});
      setHedgeTableData(item?.hedgeTableData || []);
      setLotTableData(item?.lotTableData || []);

      setProduct({
        ...product,
        ptMetalReturn: item?.ptMetalReturn || {},
        pdMetalReturn: item?.pdMetalReturn || {},
        rhMetalReturn: item?.rhMetalReturn || {},
        ptRefiningCharge: item?.ptRefiningCharge || {},
        pdRefiningCharge: item?.pdRefiningCharge || {},
        rhRefiningCharge: item?.rhRefiningCharge || {},
        advInvoice: item?.advInvoice || {},
        intInvoice: item?.intInvoice || {},
        tc: item?.tc || {},
        sc: item?.sc || {},
        af: item?.af || {},
        espi: item?.espi || {},
        fi: item?.fi || {},
        totalCharges: item?.totalCharges || '',
        totalSettlementAmount: item?.totalSettlementAmount || '',
      });
    }
  }, [item]);

  const submitSettlementInfo = async () => {
    const payLoad = {
      settlementId: item?.settlementId || '',
      ...inputData,
      shippingDocs: shippingDocs || {},
      mmiReceived: mmiReceived || {},
      mmiProcessed: mmiProcessed || {},
      hedgeTableData: hedgeTableData || [],
      lotTableData: lotTableData || [],
      ...product,
      isComplete: false,
      ...selectedCustomer,
    };

    setSubmitIsLoading(true);
    if (_.isEmpty(inputData)) {
      setToastParams({
        type: 'ERROR',
        message: 'Please fill all input and submit',
        id: new Date().getTime(),
      });
      setSubmitIsLoading(false);
      return;
    }
    try {
      await postData(SUBMIT_SETTLEMENT_INFO, {
        ...payLoad,
      });
      goBack();
      setSubmitIsLoading(false);
    } catch (e) {
      setToastParams({
        type: 'ERROR',
        message: 'Something went wrong please try agian later',
        id: new Date().getTime(),
      });
      setSubmitIsLoading(false);
    }
  };

  const completeSettlementInfo = async () => {
    const payLoad = {
      settlementId: item?.settlementId || '',
      ...inputData,
      shippingDocs: shippingDocs || {},
      mmiReceived: mmiReceived || {},
      mmiProcessed: mmiProcessed || {},
      hedgeTableData: hedgeTableData || [],
      lotTableData: lotTableData || [],
      ...product,
      isComplete: true,
      ...selectedCustomer,
    };

    setSubmitIsLoading(true);
    if (_.isEmpty(inputData)) {
      setToastParams({
        type: 'ERROR',
        message: 'Please fill all input and submit',
        id: new Date().getTime(),
      });
      setSubmitIsLoading(false);
      return;
    }
    try {
      await postData(SUBMIT_SETTLEMENT_INFO, {
        ...payLoad,
      });
      goBack();
      setSubmitIsLoading(false);
    } catch (e) {
      setToastParams({
        type: 'ERROR',
        message: 'Something went wrong please try agian later',
        id: new Date().getTime(),
      });
      setSubmitIsLoading(false);
    }
  };

  const getInputType = (value) => {
    return value.includes('_number') ? 'number' : 'text';
  };

  const metalMap = {
    ptMetalReturn: 'ptOz',
    pdMetalReturn: 'pdOz',
    rhMetalReturn: 'rhOz',
  };

  const formatValue = (value) => {
    if (value == null || isNaN(value)) return '0';
    const truncated = Math.trunc(value * 1000) / 1000;
    return truncated % 1 === 0 ? String(truncated) : truncated.toString();
  };

  const getMetalData = (metal, type) => {
    const ozPrice = lotTableData?.[0]?.[`${metal}Oz`] || 0.0;
    const avgPrice = calculateWeightedAverage(
      hedgeTableData,
      metalMap[`${metal}MetalReturn`],
      metalMap[`${metal}MetalReturn`] === 'ptOz'
        ? 'ptUnitPrice'
        : metalMap[`${metal}MetalReturn`] === 'pdOz'
        ? 'pdUnitPrice'
        : 'rhUnitPrice'
    );
    const chargeReturnPerc =
      product?.[`${metal}MetalReturn`]?.chargeReturnPerc || 0.0;
    return formatValue(avgPrice) * formatValue(ozPrice * chargeReturnPerc);
  };

  const getRefiningCharges = (metals) => {
    const refiningChargeMap = {
      ptRefiningCharge: 'ptOz',
      pdRefiningCharge: 'pdOz',
      rhRefiningCharge: 'rhOz',
    };
    return metals.reduce((sum, metal) => {
      const quantity = product?.[metal]?.quantity || 0.0;
      const chargeReturnPerc = product?.[metal]?.chargeReturnPerc || 0.0;
      let chargeReturn = 0.0;
      if (metal === 'intInvoice') {
        const advChargeReturn = product?.['advInvoice']?.chargeReturn || 0.0;
        chargeReturn =
          (chargeReturnPerc / 100 / 360) * quantity * advChargeReturn;
      } else if (metal === 'advInvoice') {
        chargeReturn = product?.[metal]?.chargeReturn || 0.0;
      } else if (
        metal === 'ptRefiningCharge' ||
        metal === 'pdRefiningCharge' ||
        metal === 'rhRefiningCharge'
      ) {
        const metalKeyOz =
          lotTableData?.[0]?.[
            metalMap[
              metal === 'ptRefiningCharge'
                ? 'ptMetalReturn'
                : metal === 'pdRefiningCharge'
                ? 'pdMetalReturn'
                : 'rhMetalReturn'
            ]
          ] || 0.0;

        const metalKeyChargeReturnPerc =
          product?.[
            metal === 'ptRefiningCharge'
              ? 'ptMetalReturn'
              : metal === 'pdRefiningCharge'
              ? 'pdMetalReturn'
              : 'rhMetalReturn'
          ]?.chargeReturnPerc || 0.0;
        const chargeReturnPerc = product?.[metal]?.chargeReturnPerc || 0.0;
        chargeReturn = formatValue(
          chargeReturnPerc * formatValue(metalKeyOz * metalKeyChargeReturnPerc)
        );
      } else if (metal === 'espi') {
        const quantity = product?.[metal]?.quantity || 0.0;
        const chargeReturnPerc =
          (product?.[metal]?.chargeReturnPerc || 0.0) / 100 / 360;
        const metals = ['pt', 'pd', 'rh'];
        const metalReturnTotal = metals.reduce(
          (sumTotal, metalkey) =>
            sumTotal + getMetalData(metalkey, 'MetalReturn'),
          0
        );
        const espiAverage = getRefiningCharges([
          'ptRefiningCharge',
          'pdRefiningCharge',
          'rhRefiningCharge',
          'advInvoice',
          'intInvoice',
          'tc',
        ]);
        const finalEspiAverage = metalReturnTotal - espiAverage;
        chargeReturn = chargeReturnPerc * quantity * finalEspiAverage;
      } else {
        chargeReturn = chargeReturnPerc * quantity;
      }
      // console.log(
      //   '@@@@@ chargeReturn ++++',
      //   metal,
      //   parseFloat(formatValue(chargeReturn))
      // );
      return sum + parseFloat(formatValue(chargeReturn));
    }, 0);
  };

  const handleSpecialCases = (metalKey) => {
    const refiningCharges = getRefiningCharges([
      'ptRefiningCharge',
      'pdRefiningCharge',
      'rhRefiningCharge',
      'advInvoice',
      'intInvoice',
      'tc',
      'sc',
      'af',
      'espi',
      'fi',
    ]);

    if (metalKey === 'totalCharges') {
      return ' - ' + formatValue(refiningCharges);
    }

    if (metalKey === 'totalSettlementAmount') {
      const metalReturn = ['pt', 'pd', 'rh'].reduce(
        (sum, metal) => sum + getMetalData(metal, 'MetalReturn'),
        0
      );
      return formatValue(metalReturn - refiningCharges);
    }

    return '';
  };

  const refiningChargeMap = {
    ptRefiningCharge: 'ptOz',
    pdRefiningCharge: 'pdOz',
    rhRefiningCharge: 'rhOz',
  };

  const refiningMap = ['intInvoice', 'tc', 'sc', 'af', 'espi', 'fi'];

  const calculateWeightedAverage = (data, ozKey, priceKey) => {
    let totalOz = 0;
    let totalValue = 0;

    data.forEach((entry) => {
      if (entry[ozKey] && entry[priceKey]) {
        totalOz += entry[ozKey];
        totalValue += entry[ozKey] * entry[priceKey];
      }
    });

    return totalOz > 0 ? (totalValue / totalOz).toFixed(2) : 0.0;
  };

  const getValueFromProduct = (keyParts, product) => {
    const [metalKey, keyValue] = keyParts;

    if (metalKey === 'totalCharges' || metalKey === 'totalSettlementAmount') {
      return handleSpecialCases(metalKey);
    }

    if (metalMap[metalKey] && keyValue === 'totalOunces') {
      const totalOunces = lotTableData?.[0]?.[metalMap[metalKey]] || 0.0;
      return formatValue(parseFloat(totalOunces));
    }

    if (
      metalMap[metalKey] &&
      (keyValue === 'quantity' || keyValue === 'chargeReturn')
    ) {
      const oz = lotTableData?.[0]?.[metalMap[metalKey]] || 0.0;
      const avgPrice = calculateWeightedAverage(
        hedgeTableData,
        metalMap[metalKey],
        metalMap[metalKey] === 'ptOz'
          ? 'ptUnitPrice'
          : metalMap[metalKey] === 'pdOz'
          ? 'pdUnitPrice'
          : 'rhUnitPrice'
      );
      const chargeReturnPerc = product?.[metalKey]?.chargeReturnPerc || 0.0;

      return keyValue === 'quantity'
        ? formatValue(oz * chargeReturnPerc)
        : formatValue(
            formatValue(avgPrice) * formatValue(oz * chargeReturnPerc)
          );
    }

    if (metalMap[metalKey] && keyValue === 'avgPrice') {
      const avgPrice = calculateWeightedAverage(
        hedgeTableData,
        metalMap[metalKey],
        metalMap[metalKey] === 'ptOz'
          ? 'ptUnitPrice'
          : metalMap[metalKey] === 'pdOz'
          ? 'pdUnitPrice'
          : 'rhUnitPrice'
      );
      return formatValue(avgPrice);
    }

    if (
      refiningChargeMap[metalKey] &&
      (keyValue === 'quantity' || keyValue === 'chargeReturn')
    ) {
      const metalKeyOz =
        lotTableData?.[0]?.[
          metalMap[
            metalKey === 'ptRefiningCharge'
              ? 'ptMetalReturn'
              : metalKey === 'pdRefiningCharge'
              ? 'pdMetalReturn'
              : 'rhMetalReturn'
          ]
        ] || 0.0;

      const chargeReturnPerc = product?.[metalKey]?.chargeReturnPerc || 0.0;
      const metalKeyChargeReturnPerc =
        product?.[
          metalKey === 'ptRefiningCharge'
            ? 'ptMetalReturn'
            : metalKey === 'pdRefiningCharge'
            ? 'pdMetalReturn'
            : 'rhMetalReturn'
        ]?.chargeReturnPerc || 0.0;
      return keyValue === 'quantity'
        ? formatValue(metalKeyOz * metalKeyChargeReturnPerc)
        : '-' +
            formatValue(
              chargeReturnPerc *
                formatValue(metalKeyOz * metalKeyChargeReturnPerc)
            );
    }

    if (refiningMap.includes(metalKey) && keyValue === 'chargeReturn') {
      if (metalKey !== 'intInvoice' && metalKey !== 'espi') {
        const quantity = product?.[metalKey]?.quantity || 0.0;
        const chargeReturnPerc = product?.[metalKey]?.chargeReturnPerc || 0.0;
        return '-' + formatValue(chargeReturnPerc * quantity);
      } else if (metalKey === 'intInvoice') {
        const quantity = product?.[metalKey]?.quantity || 0.0;
        const chargeReturnPerc =
          (product?.[metalKey]?.chargeReturnPerc || 0.0) / 100 / 360;
        const advChargeReturn = product?.['advInvoice']?.chargeReturn || 0.0;
        return '-' + formatValue(chargeReturnPerc * quantity * advChargeReturn);
      } else if (metalKey === 'espi') {
        const quantity = product?.[metalKey]?.quantity || 0.0;
        const chargeReturnPerc =
          (product?.[metalKey]?.chargeReturnPerc || 0.0) / 100 / 360;
        const metals = ['pt', 'pd', 'rh'];
        const metalReturnTotal = metals.reduce(
          (sum, metal) => sum + getMetalData(metal, 'MetalReturn'),
          0
        );
        const espiAverage = getRefiningCharges([
          'ptRefiningCharge',
          'pdRefiningCharge',
          'rhRefiningCharge',
          'advInvoice',
          'intInvoice',
          'tc',
        ]);
        const finalEspiAverage = formatValue(metalReturnTotal - espiAverage);
        return (
          '-' + formatValue(chargeReturnPerc * quantity * finalEspiAverage)
        );
      }
    }

    if (metalKey === 'espi' && keyValue === 'average') {
      const refiningCharges = getRefiningCharges([
        'ptRefiningCharge',
        'pdRefiningCharge',
        'rhRefiningCharge',
        'advInvoice',
        'intInvoice',
        'tc',
      ]);
      const metals = ['pt', 'pd', 'rh'];
      const metalReturnTotal = metals.reduce(
        (sum, metal) => sum + getMetalData(metal, 'MetalReturn'),
        0
      );
      return formatValue(formatValue(metalReturnTotal) - refiningCharges);
    }

    if (metalKey === 'metalReturn') {
      const metals = ['pt', 'pd', 'rh'];
      const total = metals.reduce(
        (sum, metal) => sum + getMetalData(metal, 'MetalReturn'),
        0
      );
      return formatValue(total);
    }

    return product[metalKey]?.[keyValue] ?? '';
  };

  const handleInputChange = (e, keyParts, product, setProduct) => {
    const value = e.target.value;
    const newValue =
      getInputType(e.target.name) === 'number' ? Number(value) || '' : value;

    if (keyParts.length === 3 || keyParts.length === 4) {
      setProduct({
        ...product,
        [keyParts[0]]: {
          ...product[keyParts[0]],
          [keyParts[1]]: newValue,
        },
      });
    } else if (keyParts.length === 2) {
      setProduct({
        ...product,
        [keyParts[0]]: newValue,
      });
    }
  };

  return (
    <PageLayout
      icon={HeaderIconSvg}
      heading={
        window.location.pathname.includes('new')
          ? 'Create Settlement'
          : 'Update Settlement'
      }
      searchPlaceholder='Search Settlement'
    >
      {isLoading ? (
        <div className='ht-80 p-relative'>
          <ActionLoader />
        </div>
      ) : (
        <>
          <div
            style={{ marginTop: 0 }}
            className='flex flex-middle c-pointer mb-20'
          >
            <div
              onClick={() => {
                goBack();
              }}
            >
              <img src={CaretIcon} className='wt-20 rotate-90 op-5' />
              <span className='fs-12 c-table-header fw-bolder'>
                Back To Settlement
              </span>
            </div>
          </div>
          <div
            className={`costSheetFilters settlementFilters ${
              isMobile ? 'mobile-view gap-3' : ''
            }`}
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
            }}
          >
            <div
              className={`flex flex-between ${isMobile ? 'flex-column' : ''} `}
            >
              <div className={`w-100`} style={{ fontSize: 18 }}>
                <span className='c-black fw-bolder flex-1 mb-8'>
                  CUSTOMER NAME:{' '}
                </span>
                <span className='c-black flex-1 mb-8'>
                  {selectedCustomer?.companyName || ''}{' '}
                </span>
                <span className='c-black fw-bolder flex-1 ml-20 mb-8'>
                  LOCATION:{' '}
                </span>
                <span className='c-black flex-1 mb-8'>
                  {selectedCustomer?.facilityCity || ''}{' '}
                </span>
              </div>
            </div>
          </div>
          <div
            className={`costSheetFilters settlementFilters ${
              isMobile ? 'mobile-view gap-3' : ''
            }`}
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
            }}
          >
            <div class='first-step'>
              <FormInput
                inputClassName='bg-blue rounded-pill'
                style={{ paddingLeft: '10px' }}
                placeholder={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `Settlement No <span style='color:red;'>*</span>`,
                    }}
                  ></div>
                }
                onChange={(e) => {
                  setInputData({
                    ...inputData,
                    settlementNo: e.target.value,
                  });
                }}
                className={`${!isMobile ? 'wt-18p mr-20' : 'wt-100p'}`}
                value={inputData.settlementNo}
                hasError={hasSubmitted && !validations.settlementNo}
                disabled={item?.isComplete}
              />

              <FormInput
                inputClassName='bg-blue rounded-pill'
                style={{ paddingLeft: '10px' }}
                placeholder={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `Contract No <span style='color:red;'>*</span>`,
                    }}
                  ></div>
                }
                onChange={(e) => {
                  setInputData({
                    ...inputData,
                    contractNo: e.target.value,
                  });
                }}
                className={`${!isMobile ? 'wt-18p mr-20' : 'wt-100p'}`}
                value={inputData.contractNo}
                hasError={hasSubmitted && !validations.contractNo}
                disabled={item?.isComplete}
              />

              <FormInput
                inputClassName='bg-blue rounded-pill'
                style={{ paddingLeft: '10px' }}
                placeholder={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `Shipment No <span style='color:red;'>*</span>`,
                    }}
                  ></div>
                }
                onChange={(e) => {
                  setInputData({
                    ...inputData,
                    shipmentNo: e.target.value,
                  });
                }}
                className={`${!isMobile ? 'wt-18p mr-20' : 'wt-100p'}`}
                value={inputData.shipmentNo}
                hasError={hasSubmitted && !validations.shipmentNo}
                disabled={item?.isComplete}
              />

              <div className={`${!isMobile ? 'wt-18p mr-20' : 'wt-100p'}`}>
                <div className='mb-4 c-gray placeholder'>
                  Received Date <span style={{ color: 'red' }}>*</span>
                </div>
                <DatePicker
                  selected={inputData.receivedDate}
                  onChange={(date) => {
                    setInputData({
                      ...inputData,
                      receivedDate: new Date(date).setHours(23, 59, 59, 59),
                    });
                  }}
                  selectsStart
                  className='form-control date-picker-fw'
                  disabled={item?.isComplete}
                />
              </div>

              <div className={`${!isMobile ? 'wt-18p mr-20' : 'wt-100p'}`}>
                <div className='mb-4 c-gray placeholder'>
                  Metal Due Date <span style={{ color: 'red' }}>*</span>
                </div>
                <DatePicker
                  selected={inputData.metalDueDate}
                  onChange={(date) => {
                    setInputData({
                      ...inputData,
                      metalDueDate: new Date(date).setHours(23, 59, 59, 59),
                    });
                  }}
                  selectsStart
                  className='form-control date-picker-fw'
                  disabled={item?.isComplete}
                />
              </div>
            </div>
            <div className='wt-100p p-4 flex flex-wrap gap-4 justify-between'>
              {/* Shipping Docs */}
              <div className='flex-1 min-w-[300px] border rounded-2xl shadow p-4 bg-white'>
                <h4 className='text-base font-bold mb-2 text-center'>
                  Shipping Docs
                </h4>

                <div className='wt-100p flex flex-wrap gap-4 justify-between pt-4'>
                  <div className='flex-1 min-w-[300px]'>
                    <span></span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <span>Units</span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <span>LM</span>
                  </div>
                </div>
                <div className='wt-100p flex flex-wrap gap-4 justify-between pt-4'>
                  <div className='flex-1 min-w-[300px] align-center'>
                    <span>Gross</span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <span></span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <FormInput
                      type='number'
                      inputClassName='bg-blue rounded-pill'
                      style={{ paddingLeft: '10px' }}
                      className={`wt-100p`}
                      value={shippingDocs.gross}
                      onChange={(e) => {
                        setShippingDocs({
                          ...shippingDocs,
                          gross: parseFloat(e.target.value) || '',
                        });
                      }}
                      disabled={item?.isComplete}
                      onKeyDown={(e) => {
                        if (['e', 'E', '+', '-'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className='wt-100p flex flex-wrap gap-4 justify-between pt-4'>
                  <div className='flex-1 min-w-[300px] align-center'>
                    <span>Tare</span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <span></span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <FormInput
                      type='number'
                      inputClassName='bg-blue rounded-pill'
                      style={{ paddingLeft: '10px' }}
                      className={`wt-100p`}
                      value={shippingDocs.tare}
                      onChange={(e) => {
                        setShippingDocs({
                          ...shippingDocs,
                          tare: parseFloat(e.target.value) || '',
                        });
                      }}
                      disabled={item?.isComplete}
                      onKeyDown={(e) => {
                        if (['e', 'E', '+', '-'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
                <div
                  className='wt-100p flex flex-wrap gap-4 justify-between pt-4'
                  style={{ fontWeight: 'bolder' }}
                >
                  <div className='flex-1 min-w-[300px] align-center'>
                    <span>Net</span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <span></span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    {shippingDocs.net}
                    {/* <FormInput
                      inputClassName="bg-blue rounded-pill"
                      style={{ paddingLeft: "10px" }}
                      isReadonly={true}
                      className={`wt-100p`}
                      value={shippingDocs.net}
                    /> */}
                  </div>
                </div>
                <div
                  className='wt-100p flex flex-wrap gap-4 justify-between pt-4'
                  style={{ fontWeight: 'bolder' }}
                >
                  <div className='flex-1 min-w-[300px] align-center'>
                    <span>Total Net</span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    {shippingDocs.total}
                    {/* <FormInput
                      inputClassName="bg-blue rounded-pill"
                      style={{ paddingLeft: "10px" }}
                      isReadonly={true}
                      className={`wt-100p`}
                      value={shippingDocs.total}
                    /> */}
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <span></span>
                  </div>
                </div>
              </div>

              {/* MMI Received */}
              <div className='flex-1 min-w-[300px] border rounded-2xl shadow p-4 bg-white'>
                <h4 className='text-base font-bold mb-2 text-center'>
                  AB Received
                </h4>

                <div className='wt-100p flex flex-wrap gap-4 justify-between pt-4'>
                  <div className='flex-1 min-w-[300px]'>
                    <span></span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <span>Units</span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <span>LM</span>
                  </div>
                </div>
                <div className='wt-100p flex flex-wrap gap-4 justify-between pt-4'>
                  <div className='flex-1 min-w-[300px] align-center'>
                    <span>Gross</span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <span></span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <FormInput
                      type='number'
                      inputClassName='bg-blue rounded-pill'
                      style={{ paddingLeft: '10px' }}
                      className={`wt-100p`}
                      value={mmiReceived.gross}
                      onChange={(e) => {
                        setMmiReceived({
                          ...mmiReceived,
                          gross: parseFloat(e.target.value) || '',
                        });
                      }}
                      disabled={item?.isComplete}
                      onKeyDown={(e) => {
                        if (['e', 'E', '+', '-'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className='wt-100p flex flex-wrap gap-4 justify-between pt-4'>
                  <div className='flex-1 min-w-[300px] align-center'>
                    <span>Tare</span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <span></span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <FormInput
                      type='number'
                      inputClassName='bg-blue rounded-pill'
                      style={{ paddingLeft: '10px' }}
                      className={`wt-100p`}
                      value={mmiReceived.tare}
                      onChange={(e) => {
                        setMmiReceived({
                          ...mmiReceived,
                          tare: parseFloat(e.target.value) || '',
                        });
                      }}
                      disabled={item?.isComplete}
                      onKeyDown={(e) => {
                        if (['e', 'E', '+', '-'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
                <div
                  className='wt-100p flex flex-wrap gap-4 justify-between pt-4'
                  style={{ fontWeight: 'bolder' }}
                >
                  <div className='flex-1 min-w-[300px] align-center'>
                    <span>Net</span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <span></span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    {mmiReceived.net}
                    {/* <FormInput
                      inputClassName="bg-blue rounded-pill"
                      style={{ paddingLeft: "10px" }}
                      isReadonly={true}
                      className={`wt-100p`}
                      value={mmiReceived.net}
                    /> */}
                  </div>
                </div>
                <div
                  className='wt-100p flex flex-wrap gap-4 justify-between pt-4'
                  style={{ fontWeight: 'bolder' }}
                >
                  <div className='flex-1 min-w-[300px] align-center'>
                    <span>Total Net</span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    {mmiReceived.total}
                    {/* <FormInput
                      inputClassName="bg-blue rounded-pill"
                      style={{ paddingLeft: "10px" }}
                      isReadonly={true}
                      className={`wt-100p`}
                      value={mmiReceived.total}
                    /> */}
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <span></span>
                  </div>
                </div>
              </div>

              {/* MMI Processed */}
              <div className='flex-1 min-w-[300px] border rounded-2xl shadow p-4 bg-white'>
                <h4 className='text-base font-bold mb-2 text-center'>
                  AB Processed
                </h4>

                <div className='wt-100p flex flex-wrap gap-4 justify-between pt-4'>
                  <div className='flex-1 min-w-[300px]'>
                    <span></span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <span>NET</span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <span>DRY</span>
                  </div>
                </div>
                <div className='wt-100p flex flex-wrap gap-4 justify-between pt-4'>
                  <div className='flex-1 min-w-[300px] align-center'>
                    <span>Mono / WC</span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <FormInput
                      type='number'
                      inputClassName='bg-blue rounded-pill'
                      style={{ paddingLeft: '10px' }}
                      className={`wt-100p`}
                      value={mmiProcessed.monoNet}
                      onChange={(e) => {
                        setMmiProcessed({
                          ...mmiProcessed,
                          monoNet: parseFloat(e.target.value) || '',
                        });
                      }}
                      disabled={item?.isComplete}
                      onKeyDown={(e) => {
                        if (['e', 'E', '+'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <FormInput
                      type='number'
                      inputClassName='bg-blue rounded-pill'
                      style={{ paddingLeft: '10px' }}
                      className={`wt-100p`}
                      value={mmiProcessed.monoDry}
                      onChange={(e) => {
                        setMmiProcessed({
                          ...mmiProcessed,
                          monoDry: parseFloat(e.target.value) || '',
                        });
                      }}
                      disabled={item?.isComplete}
                      onKeyDown={(e) => {
                        if (['e', 'E', '+'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className='wt-100p flex flex-wrap gap-4 justify-between pt-4'>
                  <div className='flex-1 min-w-[300px] align-center'>
                    <span>BHD</span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <FormInput
                      type='number'
                      inputClassName='bg-blue rounded-pill'
                      style={{ paddingLeft: '10px' }}
                      className={`wt-100p`}
                      value={mmiProcessed.bhdNet}
                      onChange={(e) => {
                        setMmiProcessed({
                          ...mmiProcessed,
                          bhdNet: parseFloat(e.target.value) || '',
                        });
                      }}
                      disabled={item?.isComplete}
                      onKeyDown={(e) => {
                        if (['e', 'E', '+'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <FormInput
                      type='number'
                      inputClassName='bg-blue rounded-pill'
                      style={{ paddingLeft: '10px' }}
                      className={`wt-100p`}
                      value={mmiProcessed.bhdDry}
                      onChange={(e) => {
                        setMmiProcessed({
                          ...mmiProcessed,
                          bhdDry: parseFloat(e.target.value) || '',
                        });
                      }}
                      disabled={item?.isComplete}
                      onKeyDown={(e) => {
                        if (['e', 'E', '+'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className='wt-100p flex flex-wrap gap-4 justify-between pt-4'>
                  <div className='flex-1 min-w-[300px] align-center'>
                    <span>Samples</span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <FormInput
                      type='number'
                      inputClassName='bg-blue rounded-pill'
                      style={{ paddingLeft: '10px' }}
                      className={`wt-100p`}
                      value={mmiProcessed.samplesNet}
                      onChange={(e) => {
                        setMmiProcessed({
                          ...mmiProcessed,
                          samplesNet: parseFloat(e.target.value) || '',
                        });
                      }}
                      disabled={item?.isComplete}
                      onKeyDown={(e) => {
                        if (['e', 'E', '+'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <FormInput
                      type='number'
                      inputClassName='bg-blue rounded-pill'
                      style={{ paddingLeft: '10px' }}
                      className={`wt-100p`}
                      value={mmiProcessed.samplesDry}
                      onChange={(e) => {
                        setMmiProcessed({
                          ...mmiProcessed,
                          samplesDry: parseFloat(e.target.value) || '',
                        });
                      }}
                      disabled={item?.isComplete}
                      onKeyDown={(e) => {
                        if (['e', 'E', '+'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className='wt-100p flex flex-wrap gap-4 justify-between pt-4'>
                  <div className='flex-1 min-w-[300px] align-center'>
                    <span>Trash</span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <FormInput
                      type='number'
                      inputClassName='bg-blue rounded-pill'
                      style={{ paddingLeft: '10px' }}
                      className={`wt-100p`}
                      value={mmiProcessed.trashNet}
                      onChange={(e) => {
                        setMmiProcessed({
                          ...mmiProcessed,
                          trashNet: parseFloat(e.target.value) || '',
                        });
                      }}
                      disabled={item?.isComplete}
                      onKeyDown={(e) => {
                        if (['e', 'E', '+'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <FormInput
                      type='number'
                      inputClassName='bg-blue rounded-pill'
                      style={{ paddingLeft: '10px' }}
                      className={`wt-100p`}
                      value={mmiProcessed.trashDry}
                      onChange={(e) => {
                        setMmiProcessed({
                          ...mmiProcessed,
                          trashDry: parseFloat(e.target.value) || '',
                        });
                      }}
                      disabled={item?.isComplete}
                      onKeyDown={(e) => {
                        if (['e', 'E', '+'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className='wt-100p flex flex-wrap gap-4 justify-between pt-4'>
                  <div className='flex-1 min-w-[300px] align-center'>
                    <span>Magnetics</span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <FormInput
                      type='number'
                      inputClassName='bg-blue rounded-pill'
                      style={{ paddingLeft: '10px' }}
                      className={`wt-100p`}
                      value={mmiProcessed.magneticsNet}
                      onChange={(e) => {
                        setMmiProcessed({
                          ...mmiProcessed,
                          magneticsNet: parseFloat(e.target.value) || '',
                        });
                      }}
                      disabled={item?.isComplete}
                      onKeyDown={(e) => {
                        if (['e', 'E', '+'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    <FormInput
                      type='number'
                      inputClassName='bg-blue rounded-pill'
                      style={{ paddingLeft: '10px' }}
                      className={`wt-100p`}
                      value={mmiProcessed.magneticsDry}
                      onChange={(e) => {
                        setMmiProcessed({
                          ...mmiProcessed,
                          magneticsDry: parseFloat(e.target.value) || '',
                        });
                      }}
                      disabled={item?.isComplete}
                      onKeyDown={(e) => {
                        if (['e', 'E', '+'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
                <div
                  className='wt-100p flex flex-wrap gap-4 justify-between pt-4'
                  style={{ fontWeight: 'bolder' }}
                >
                  <div className='flex-1 min-w-[300px] align-center'>
                    <span>Total Processed</span>
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    {mmiProcessed.totalProcessedNet}
                    {/* <FormInput
                      inputClassName="bg-blue rounded-pill"
                      style={{ paddingLeft: "10px" }}
                      className={`wt-100p`}
                      value={mmiProcessed.totalProcessedNet}
                      isReadonly={true}
                    /> */}
                  </div>
                  <div className='flex-1 min-w-[300px]'>
                    {mmiProcessed.totalProcessedDry}
                    {/* <FormInput
                      inputClassName="bg-blue rounded-pill"
                      style={{ paddingLeft: "10px" }}
                      className={`wt-100p`}
                      value={mmiProcessed.totalProcessedDry}
                      isReadonly={true}
                    /> */}
                  </div>
                </div>
              </div>
            </div>

            <div className='wt-100p p-4 flex flex-wrap gap-4 justify-between'>
              <div className='flex-1'>
                {!createHedge && (
                  <div className='wt-100p flex flex-wrap gap-4 justify-content-end'>
                    <Button
                      type='primary'
                      style={{
                        backgroundColor: 'green',
                        borderColor: 'green',
                      }}
                      onClick={() => {
                        setHedgeDetails({});
                        setCreateHedge(!createHedge);
                      }}
                      icon={<PlusOutlined />}
                      size={'default'}
                      disabled={item?.isComplete}
                    />
                  </div>
                )}

                <div className='mt-2'>
                  <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <thead>
                      <tr>
                        <th style={cellStyle}>Hedge No</th>
                        <th style={cellStyle}>Hedge Date</th>
                        <th style={cellStyle}>PT Oz</th>
                        <th style={cellStyle}>PT Unit Price</th>
                        <th style={cellStyle}>PD Oz</th>
                        <th style={cellStyle}>PD Unit Price</th>
                        <th style={cellStyle}>RH Oz</th>
                        <th style={cellStyle}>RH Unit Price</th>
                        <th style={{ ...cellStyle, width: 150 }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(hedgeTableData || []).map((hedge, index) => {
                        const hedgeDate = new Date(hedge.hedgeDate);
                        return (
                          <>
                            <tr index={index}>
                              <td style={cellStyle}>{hedge.hedgeNo}</td>
                              <td style={cellStyle}>{`${String(
                                hedgeDate.getMonth() + 1
                              ).padStart(2, '0')}-${String(
                                hedgeDate.getDate()
                              ).padStart(
                                2,
                                '0'
                              )}-${hedgeDate.getFullYear()}`}</td>
                              <td style={cellStyle}>{hedge.ptOz}</td>
                              <td style={cellStyle}>{hedge.ptUnitPrice}</td>
                              <td style={cellStyle}>{hedge.pdOz}</td>
                              <td style={cellStyle}>{hedge.pdUnitPrice}</td>
                              <td style={cellStyle}>{hedge.rhOz}</td>
                              <td style={cellStyle}>{hedge.rhUnitPrice}</td>
                              <td style={cellStyle}>
                                <Button
                                  type='primary'
                                  style={{
                                    backgroundColor: 'red',
                                    borderColor: 'red',
                                    margin: 0,
                                  }}
                                  onClick={() => {
                                    setHedgeTableData((prevItems) =>
                                      prevItems.filter(
                                        (_, ind) => ind !== index
                                      )
                                    );
                                  }}
                                  icon={<CloseOutlined />}
                                  size={'default'}
                                  disabled={item?.isComplete}
                                />
                              </td>
                            </tr>
                          </>
                        );
                      })}
                      {createHedge && (
                        <tr index={'new'}>
                          {[
                            'hedgeNo',
                            'hedgeDate',
                            'ptOz',
                            'ptUnitPrice',
                            'pdOz',
                            'pdUnitPrice',
                            'rhOz',
                            'rhUnitPrice',
                          ].map((value) => {
                            return (
                              <td style={cellStyle}>
                                {value !== 'hedgeDate' ? (
                                  <FormInput
                                    {...(value !== 'hedgeNo' &&
                                    value !== 'hedgeDate'
                                      ? { type: 'number' }
                                      : {})}
                                    inputClassName='bg-blue rounded-pill'
                                    style={{ paddingLeft: '10px' }}
                                    className={`wt-100p`}
                                    value={hedgeDetails[value]}
                                    onChange={(e) => {
                                      setHedgeDetails({
                                        ...hedgeDetails,
                                        [value]:
                                          value !== 'hedgeNo'
                                            ? Number(e.target.value) || ''
                                            : e.target.value || '',
                                      });
                                    }}
                                    disabled={item?.isComplete}
                                    onKeyDown={(e) => {
                                      if (
                                        ['e', 'E', '+', '-'].includes(e.key) &&
                                        value !== 'hedgeNo' &&
                                        value !== 'hedgeDate'
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                  />
                                ) : (
                                  <DatePicker
                                    selected={hedgeDetails[value]}
                                    onChange={(date) => {
                                      setHedgeDetails({
                                        ...hedgeDetails,
                                        [value]: new Date(date).setHours(
                                          23,
                                          59,
                                          59,
                                          59
                                        ),
                                      });
                                    }}
                                    selectsStart
                                    className='form-control date-picker-fw'
                                    disabled={item?.isComplete}
                                  />
                                )}
                              </td>
                            );
                          })}
                          <td style={cellStyle}>
                            <Button
                              type='primary'
                              style={{
                                backgroundColor: 'blue',
                                borderColor: 'blue',
                                margin: 0,
                              }}
                              onClick={() => {
                                const allEmpty = Object.values(
                                  hedgeDetails
                                ).every((value) => value === '');
                                if (allEmpty) {
                                  setToastParams({
                                    type: 'ERROR',
                                    message: 'Please fill all fields',
                                    id: new Date().getTime(),
                                  });
                                  return;
                                }
                                setHedgeTableData((prevItems) => [
                                  ...prevItems,
                                  hedgeDetails,
                                ]);
                                setCreateHedge(!createHedge);
                              }}
                              icon={<SaveOutlined />}
                              size={'default'}
                            />
                            <Button
                              type='primary'
                              style={{
                                backgroundColor: 'red',
                                borderColor: 'red',
                                marginLeft: 10,
                              }}
                              onClick={() => {
                                setCreateHedge(!createHedge);
                              }}
                              icon={<CloseOutlined />}
                              size={'default'}
                            />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className='wt-100p p-4 flex flex-wrap gap-4 justify-between'>
              <div className='flex-1'>
                {!createLot && (
                  <div className='wt-100p flex flex-wrap gap-4 justify-content-end'>
                    <Button
                      type='primary'
                      style={{
                        backgroundColor: 'green',
                        borderColor: 'green',
                      }}
                      onClick={() => {
                        setLotDetails({});
                        setCreateLot(!createLot);
                      }}
                      icon={<PlusOutlined />}
                      size={'default'}
                      disabled={item?.isComplete}
                    />
                  </div>
                )}

                <div className='mt-2'>
                  <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <thead>
                      <tr>
                        <th style={cellStyle}>Lot No</th>
                        <th style={cellStyle}>Sample No</th>
                        <th style={cellStyle}>H2O %</th>
                        <th style={cellStyle}>Net Dry</th>
                        <th style={cellStyle}>Sample Dry</th>
                        <th style={cellStyle}>PT PPM</th>
                        <th style={cellStyle}>PT Oz</th>
                        <th style={cellStyle}>PD PPM</th>
                        <th style={cellStyle}>PD Oz</th>
                        <th style={cellStyle}>RH PPM</th>
                        <th style={cellStyle}>RH Oz</th>
                        <th style={{ ...cellStyle, width: 150 }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(lotTableData || []).map((lotData, index) => {
                        return (
                          <>
                            <tr index={index}>
                              <td style={cellStyle}>{lotData.lotNo}</td>
                              <td style={cellStyle}>{lotData.sampleNo}</td>
                              <td style={cellStyle}>{lotData.h20}</td>
                              <td style={cellStyle}>{lotData.netDry}</td>
                              <td style={cellStyle}>{lotData.sampleDry}</td>
                              <td style={cellStyle}>{lotData.ptPpm}</td>
                              <td style={cellStyle}>{lotData.ptOz}</td>
                              <td style={cellStyle}>{lotData.pdPpm}</td>
                              <td style={cellStyle}>{lotData.pdOz}</td>
                              <td style={cellStyle}>{lotData.rhPpm}</td>
                              <td style={cellStyle}>{lotData.rhOz}</td>
                              <td style={cellStyle}>
                                <Button
                                  type='primary'
                                  style={{
                                    backgroundColor: 'red',
                                    borderColor: 'red',
                                    margin: 0,
                                  }}
                                  onClick={() => {
                                    setLotTableData((prevItems) =>
                                      prevItems.filter(
                                        (_, ind) => ind !== index
                                      )
                                    );
                                  }}
                                  icon={<CloseOutlined />}
                                  size={'default'}
                                  disabled={item?.isComplete}
                                />
                              </td>
                            </tr>
                          </>
                        );
                      })}

                      {createLot && (
                        <tr index={'new'}>
                          {[
                            'lotNo',
                            'sampleNo',
                            'h2O',
                            'netDry',
                            'sampleDry',
                            'ptPpm',
                            'ptOz',
                            'pdPpm',
                            'pdOz',
                            'rhPpm',
                            'rhOz',
                          ].map((value) => {
                            return (
                              <td style={cellStyle}>
                                <FormInput
                                  {...(value !== 'lotNo' && value !== 'sampleNo'
                                    ? { type: 'number' }
                                    : {})}
                                  inputClassName='bg-blue rounded-pill'
                                  style={{ paddingLeft: '10px' }}
                                  className={`wt-100p`}
                                  value={lotDetails[value]}
                                  onChange={(e) => {
                                    setLotDetails({
                                      ...lotDetails,
                                      [value]:
                                        value !== 'lotNo' &&
                                        value !== 'sampleNo'
                                          ? Number(e.target.value) || ''
                                          : e.target.value || '',
                                    });
                                  }}
                                  disabled={item?.isComplete}
                                  onKeyDown={(e) => {
                                    if (
                                      ['e', 'E', '+', '-'].includes(e.key) &&
                                      value !== 'lotNo' &&
                                      value !== 'sampleNo'
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                              </td>
                            );
                          })}
                          <td style={cellStyle}>
                            <Button
                              type='primary'
                              style={{
                                backgroundColor: 'blue',
                                borderColor: 'blue',
                              }}
                              onClick={() => {
                                const allEmpty = Object.values(
                                  lotDetails
                                ).every((value) => value === '');
                                if (allEmpty) {
                                  setToastParams({
                                    type: 'ERROR',
                                    message: 'Please fill all fields',
                                    id: new Date().getTime(),
                                  });
                                  return;
                                }
                                setLotTableData((prevItems) => [
                                  ...prevItems,
                                  lotDetails,
                                ]);
                                setCreateLot(!createLot);
                              }}
                              icon={<SaveOutlined />}
                              size={'default'}
                            />
                            <Button
                              type='primary'
                              style={{
                                backgroundColor: 'red',
                                borderColor: 'red',
                                marginLeft: 10,
                              }}
                              onClick={() => {
                                setCreateLot(!createLot);
                              }}
                              icon={<CloseOutlined />}
                              size={'default'}
                            />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className='wt-100p p-4 flex flex-wrap justify-between'>
              <div className='flex-1'>
                <div className='wt-100p flex flex-wrap justify-between t-border'>
                  {productData &&
                    productData.header &&
                    productData.header.map((value, index) => {
                      return (
                        <div
                          className={`flex-1 min-w-[300px] text-center p-2 ${
                            index !== 8 && 'b-right'
                          } `}
                        >
                          <span>{value}</span>
                        </div>
                      );
                    })}
                </div>
                {(productData.data || []).map((row, rowIndex) => (
                  <div
                    key={`row-${rowIndex}`}
                    className='wt-100p flex flex-wrap justify-between skip-t-border'
                  >
                    {(row || []).map((cell, colIndex) => {
                      const keyParts = cell.split('_');
                      const isInput = keyParts.length > 1;
                      const isNonInput =
                        keyParts[3] === 'nonInput' ||
                        keyParts[2] === 'nonInput' ||
                        keyParts[4] === 'nonInput';
                      return (
                        <div
                          key={`cell-${rowIndex}-${colIndex}`}
                          className={`flex-1 min-w-[300px] text-center p-2 ${
                            colIndex !== 8 ? 'b-right' : ''
                          }`}
                          style={{ alignContent: 'center' }}
                        >
                          {cell !== '' ? (
                            isInput ? (
                              cell.endsWith('_date') ? (
                                <DatePicker
                                  selected={getValueFromProduct(
                                    keyParts,
                                    product
                                  )}
                                  onChange={(date) => {
                                    if (keyParts.length === 3) {
                                      setProduct({
                                        ...product,
                                        [keyParts[0]]: {
                                          ...product[keyParts[0]],
                                          [keyParts[1]]: new Date(
                                            date
                                          ).setHours(23, 59, 59, 59),
                                        },
                                      });
                                    } else {
                                      setProduct({
                                        ...product,
                                        [keyParts[0]]: new Date(date).setHours(
                                          23,
                                          59,
                                          59,
                                          59
                                        ),
                                      });
                                    }
                                  }}
                                  className='form-control date-picker-fw'
                                  disabled={item?.isComplete}
                                />
                              ) : isNonInput ? (
                                <div
                                  style={{ fontSize: 14, fontWeight: 'bolder' }}
                                >
                                  <CurrencyFormat
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={''}
                                    value={getValueFromProduct(
                                      keyParts,
                                      product
                                    )}
                                  />
                                </div>
                              ) : (
                                <FormInput
                                  name={`${cell} disable-autofill-123`}
                                  type={getInputType(cell)}
                                  inputClassName='bg-blue rounded-pill'
                                  style={{ paddingLeft: '10px' }}
                                  autoComplete='off'
                                  className='wt-100p'
                                  value={getValueFromProduct(keyParts, product)}
                                  onChange={(e) =>
                                    handleInputChange(
                                      e,
                                      keyParts,
                                      product,
                                      setProduct
                                    )
                                  }
                                  disabled={item?.isComplete}
                                  onKeyDown={(e) => {
                                    if (
                                      ['e', 'E', '+', '-'].includes(e.key) &&
                                      getInputType(cell) === 'number'
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                              )
                            ) : (
                              <div
                                style={{
                                  fontWeight:
                                    cell === 'Metal Return Value ($)' ||
                                    cell === 'Total Charges ($)' ||
                                    cell === 'Total Settlement Amt ($)'
                                      ? 'bolder'
                                      : 'normal',
                                }}
                              >
                                <span>{cell}</span>
                              </div>
                            )
                          ) : null}
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>
            </div>
            <div className='wt-100p p-4 flex flex-row gap-4 justify-content-end'>
              <Button
                type='primary'
                disabled={submitIsLoading || item?.isComplete}
                onClick={() => {
                  submitSettlementInfo();
                }}
                className={isMobile ? 'auto' : 'wt-150'}
              >
                Save
              </Button>

              <Button
                type='primary'
                disabled={submitIsLoading || item?.isComplete}
                onClick={() => {
                  completeSettlementInfo();
                }}
                className={isMobile ? 'auto' : 'wt-150'}
              >
                Complete
              </Button>
            </div>
          </div>
        </>
      )}
      <Toast
        type={toastParams.type}
        message={toastParams.message}
        id={toastParams.id}
      />
    </PageLayout>
  );
};

export default CreateSettlement;
